<template>
  <div class="stash-card-content px-6" data-test="stash-card-content">
    <!-- @slot Default slot, for rendering any card content -->
    <slot></slot>
  </div>
</template>
